import React from "react";

import VectorR from './images/elements/HomePage/Vector Right.png'
import VectorL from './images/elements/HomePage/Vector Left.png'
import Temple from './images/elements/HomePage/Temple.png'
import CloudR from './images/elements/HomePage/HomePage Right Cloud.png'
import CloudL from './images/elements/HomePage/HomePage Left Cloud.png'

import Top from './images/icons/up.png'
import Egypt from './images/icons/egypt.png'
import Dark from './images/icons/moon.png'

import {Home_AR} from '.././js/script.js'

import { NavLink } from "react-router-dom";


const Home = () => (
  <div>
    <div className="main">

      <div className="art">
        <h1 className="title" id="t1"> Dhul Hijjah </h1>
        <div className="des">
          <img src={VectorR} alt="Right Vector" />
          <p className="p1" id="p1"> THE IMPORTANCE OF 10 DAYS </p>
          <img src={VectorL} alt="Left Vector" />
        </div>
        <img src={Temple} alt="Temple" style={{ marginTop: "10vh" }}/>
      </div>

      <div className="art" style={{ marginLeft: "1vh" }} id="art2">

        <div className="box2 bord-gab">
          <h1 id="p2">What is Dhul Hijjah?</h1>
          <p id="p3"> Dhul Hijjah is the twelfth and final month of the Islamic lunar calendar. It is a significant month in Islam because it is associated with the annual Hajj pilgrimage to the holy city of Mecca </p>
        </div>

        <div className="box2 bord-gab">
          <h1 id="p4">Why is it Important?</h1>
          <p id="p5"> The first 10 days of Dhul Hijjah are considered to be the best 10 days of the year, a time of amplified reward and mercy. During these 10 days, Muslims witness the day of Arafah, Hajj, and Eid ul-Adha. You can make the most of the blessed 10 days of Dhul Hijjah by increasing your worship and remembrance of Allah SWT. </p>
        </div>

        <div className="box2 btn" style={{ padding: 0 }}> <NavLink to="/contact" activeClassName="x" style={{ textDecoration: "none" }}> <h1 style={{ fontFamily: "Cairo", fontSize: "26px" }} id="p6"> LEARN MORE </h1> </NavLink> </div>

      </div>

    </div>
    <img src={CloudR} style={{ position: "absolute", bottom: "0", right: "0" }} alt="Right Cloud" className="cloud"/>
    <img src={CloudL} style={{ position: "absolute", bottom: "0", left: "0" }} alt="Left Cloud" className="cloud"/>

    <div className="features">
    <a href="#"> <img src={Top} width="40" style={{ border: 'none' }} id="toTop" className="test"/></a>
    <a href="#" onClick={Home_AR}> <img src={Egypt} width="40"/></a>
    <a href="#"> <img src={Dark} width="40"/></a>
    </div>
    
  </div>
);
export default Home;